import ajax from "./axios";

//纠错
export const reqSearchJC = (param, callback) =>
  ajax.post("/search/search-jc", param, callback);

//搜索建议
export const reqSearchSu = (param, callback) =>
  ajax.post("/search/sugguest", param, callback);

//获取master code列表
export const reqMstCodes = (param, callback) =>
  ajax.get("/t-mst-codes/list", param, callback);

//获取zwgk code列表
export const reqCategorys = (param, callback) =>
  ajax.get("/girr-info/listZwgk", param, callback);

//设置热点信息
export const reqSetHotInfo = (param, callback) =>
  ajax.get("/search/setHotInfo", param, callback);

//获取热点信息 包含热词
export const reqGetHotInfo = (param, callback) =>
  ajax.get("/search/getHotInfo", param, callback);

//搜索全部
export const reqGetAllInfo = (param, callback) =>
  ajax.post("/search/search-all", param, callback);

//搜索新闻动态
export const reqGetNewsInfo = (param, callback) =>
  ajax.post("/search/search-news", param, callback);

//搜索政策文件
export const reqGetFilesInfo = (param, callback) =>
  ajax.post("/search/search-xxgk", param, callback);

//搜索政民互动
export const reqGetKbInfo = (param, callback) =>
  ajax.post("/search/search-kb", param, callback);

//搜索办事服务
export const reqGetFwInfo = (param, callback) =>
  ajax.post("/search/search-fw", param, callback);
